(function () {
  if (window.__cppProviderCommissionsInit) return;
  window.__cppProviderCommissionsInit = true;

  var providerSelector = "[data-clinic-provider-select]";
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function cartEndpoint(path) {
    return cartRoot.replace(/\/?$/, "/") + path;
  }

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function providerSelects() {
    return document.querySelectorAll(providerSelector);
  }

  function findOption(select, value) {
    var target = normalize(value);

    for (var index = 0; index < select.options.length; index += 1) {
      if (normalize(select.options[index].value) === target) {
        return select.options[index];
      }
    }

    return null;
  }

  function addMissingOption(select, value) {
    var option = new Option(value, value, true, true);
    var noOneOption = findOption(select, "No one");

    if (noOneOption) {
      select.insertBefore(option, noOneOption);
    } else {
      select.add(option);
    }

    return option;
  }

  function setSelectValue(value) {
    var provider = String(value || "").trim();
    if (!provider) return;

    providerSelects().forEach(function (select) {
      var option = findOption(select, provider) || addMissingOption(select, provider);
      select.value = option.value;
    });
  }

  function updateProvider(provider) {
    return fetch(cartEndpoint("cart/update.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          clinic_provider: provider,
        },
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to update clinic provider");
      return response.json();
    });
  }

  function syncFromCart() {
    return fetch(cartEndpoint("cart.js"), {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load cart");
        return response.json();
      })
      .then(function (cart) {
        setSelectValue(cart && cart.attributes && cart.attributes.clinic_provider);
      })
      .catch(function () {});
  }

  function cleanProviderQueryParams() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("cp");
      url.searchParams.delete("clinic_provider");

      var query = url.searchParams.toString();
      window.history.replaceState(null, "", url.pathname + (query ? "?" + query : "") + url.hash);
    } catch (error) {}
  }

  function applyProviderFromQueryParam() {
    var params;

    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      syncFromCart();
      return;
    }

    var provider = String(params.get("cp") || params.get("clinic_provider") || "").trim();
    if (!provider) {
      syncFromCart();
      return;
    }

    updateProvider(provider)
      .then(function (cart) {
        setSelectValue((cart && cart.attributes && cart.attributes.clinic_provider) || provider);
        cleanProviderQueryParams();
      })
      .catch(function () {});
  }

  function missingRequiredProvider() {
    var selects = providerSelects();

    for (var index = 0; index < selects.length; index += 1) {
      var select = selects[index];
      if (select.required && !select.disabled && select.offsetParent !== null && !select.value) {
        return select;
      }
    }

    return null;
  }

  function blockCheckoutWithoutProvider(event) {
    var select = missingRequiredProvider();
    if (!select) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    select.focus();
    select.reportValidity();
  }

  document.addEventListener("change", function (event) {
    var select = event.target.closest && event.target.closest(providerSelector);
    if (!select || !select.value) return;

    select.setAttribute("aria-busy", "true");

    updateProvider(select.value)
      .then(function (cart) {
        setSelectValue(
          (cart && cart.attributes && cart.attributes.clinic_provider) || select.value,
        );
        document.dispatchEvent(
          new CustomEvent("cpp:provider-updated", {
            detail: {
              provider: select.value,
            },
          }),
        );
      })
      .catch(function () {
        syncFromCart();
      })
      .finally(function () {
        select.removeAttribute("aria-busy");
      });
  });

  document.addEventListener(
    "click",
    function (event) {
      if (event.target.closest && event.target.closest('button[name="checkout"], #checkout')) {
        blockCheckoutWithoutProvider(event);
      }
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (event) {
      if (event.target.matches && event.target.matches("#cart-form, .cart-form")) {
        blockCheckoutWithoutProvider(event);
      }
    },
    true,
  );

  ["shopify:section:load", "cart:updated", "cart-drawer:opened", "cart-drawer:rendered"].forEach(
    function (eventName) {
      document.addEventListener(eventName, function () {
        window.setTimeout(syncFromCart, 0);
      });
    },
  );

  if (/\b(cp|clinic_provider)=/i.test(window.location.search)) {
    applyProviderFromQueryParam();
  } else {
    syncFromCart();
  }
})();
